import { Mapper } from "../domain/mappers/Mapper";
import { UserDTO, UserForm } from "../domain/models/dto/UserDTO";
import { SimpleMapper } from "./SimpleMapper";
import phoneMapperFactory from "./PhoneMapper";
import addressMapperFactory from "./AddressMapper";

class UserMapperImpl extends SimpleMapper<UserForm, UserDTO> {
    protected toDTOFields: string[] = [
        "firstName",
        "lastName",
        "about",
        "telegram",
        "country",
        "city",
        "address",
        "allowGeo",
        "reviewsCount",
        "avgRating",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "id",
        "createdAt",
        "updatedAt",
    ];

    toDTO(form: UserForm): UserDTO {
        const dto = super.toDTO(form);
        if (form.phones?.length) {
            const phoneMapper = phoneMapperFactory();
            dto.phones = form.phones
                .filter((phone) => phone.id || phone.phone)
                .map((phone) => phoneMapper.toDTO(phone));
        }
        if (form.address) {
            const addressMapper = addressMapperFactory();
            dto.address = addressMapper.toDTO(form.address);
        }
        return dto;
    }
}

export default function userMapperFactory(): Mapper<UserForm, UserDTO> {
    return new UserMapperImpl();
}
